<template>
	<MainLayout>
		<div class="container">
			<b-overlay no-wrap :show="loadingExport" />
			<div class="box">
				<b-row>
					<b-col>
						<h2 class="inline-heading">
							Cotizador reservas de proveedores
						</h2>
					</b-col>
				</b-row>
				<hr />

				<Filters
					id="suppliers-reservations-index-filters"
					:filters.sync="filters"
					@search="
						() =>
							$root.$emit(
								'bv::refresh::table',
								'supplier-prices-index-list'
							)
					"
				/>
				<hr />
				<b-row>
					<b-col
						align-self="start"
						v-if="$hasPermission('supplierCost.updateAll')"
					>
						<b-button
							v-b-modal.update-all
							variant="warning"
							class="mb-2"
						>
							CALCULAR Y ACTUALIZAR TODOS
						</b-button>
					</b-col>
					<b-col align-self="end" class="text-right">
						<b-button
							variant="primary"
							class="ml-2 mb-2"
							@click="updateAllView"
						>
							GUARDAR COSTOS
						</b-button>

						<b-button
							@click="exportExcel()"
							variant="success"
							class="ml-2 mb-2"
						>
							<md-icon icon="" />Exportar XLS
						</b-button>
					</b-col>
				</b-row>
				<!-- cuadro de dialogo en observacion -->
				<!-- <b-modal id="update-all" ok-only ok-title="Cerrar">
					<b-button
						v-b-modal.update-all
						variant="warning"
						class="mb-2"
					>
						CALCULAR Y ACTUALIZAR TODOS
					</b-button>

					<b-col align-self="end" class="text-right">
						<b-button
							v-if="$hasPermission('supplierCost.save')"
							variant="primary"
							class="ml-2 mb-2"
							@click="updateAllView"
						>
							GUARDAR COSTOS
						</b-button>

						<b-button
							v-if="$hasPermission('supplierCost.export.xls')"
							@click="exportExcel()"
							variant="success"
							class="ml-2 mb-2"
						>
							<md-icon icon="" />
							Exportar XLS
						</b-button>
					</b-col>
				</b-modal> -->

				<b-modal id="update-all" ok-only ok-title="Cerrar">
					<h4>Calcular y actualizar todos los registros</h4>
					<b-button
						v-b-modal.update-all
						variant="primary"
						class="mb-2"
						@click="updateAll"
					>
						INICIAR
					</b-button>
					<div class="text-center">
						<div>
							<p v-for="(text, i) in updateAllSteps" :key="i">
								{{ text }}
							</p>
						</div>
						<b-spinner small v-if="runUpdateAll" />
						<br />
						<b-button
							variant="danger"
							@click="runUpdateAll = false"
							v-if="runUpdateAll"
						>
							DETENER
						</b-button>
					</div>
				</b-modal>


				<!-- Trace rate plan -->
				<b-modal id="trace-data" ref="trace-data" size="xl" ok-only ok-title="Cerrar" dialog-class="trace-modal">
					<template #modal-title>
						<md-icon icon="info" class="mr-2"></md-icon>
						Detalles cálculo de costo proveedor
					</template>

					<b-tabs content-class="mt-3" fill>
						<b-tab title="Principal" active>
							<!-- Tabla -->
							<div class="table-section mb-3">
								<div class="table-container">
									<b-form-input v-model="trace.filter" v-if="false"></b-form-input>
									<b-table
										responsive
										stacked="sm"
										show-empty
										small
										striped
										hover
										bordered
										selectable
										select-mode="single"
										@row-selected="onRowSelected"
										:items="trace.items"
										:fields="trace.columns"
										:filter="trace.filter">

										<template #cell(travelWindow)="row">
											<div v-if="row.item.ratePlanModel">
												<div v-if="row.item.ratePlanModel.travelWindowStartDate && row.item.ratePlanModel.travelWindowEndDate" class="text-nowrap">
													<md-icon icon="date_range" class="small-icon text-muted"></md-icon>
													<small>{{ formatDate(row.item.ratePlanModel.travelWindowStartDate) }}</small>
													<br>
													<small class="ml-3">{{ formatDate(row.item.ratePlanModel.travelWindowEndDate) }}</small>
												</div>
												<small v-else class="text-muted">-</small>
											</div>
											<small v-else class="text-muted">-</small>
										</template>

										<template #cell(serviceTime)="row">
											<div v-if="row.item.ratePlanModel">
												<div v-if="row.item.ratePlanModel.serviceStartTime && row.item.ratePlanModel.serviceEndTime" class="text-nowrap">
													<md-icon icon="schedule" class="small-icon text-muted"></md-icon>
													<small>{{ formatTime(row.item.ratePlanModel.serviceStartTime) }}</small>
													-
													<small>{{ formatTime(row.item.ratePlanModel.serviceEndTime) }}</small>
												</div>
												<small v-else class="text-muted">-</small>
											</div>
											<small v-else class="text-muted">-</small>
										</template>

										<template #cell(ratePlanId)="row">
											<a
												:href="'/rate-plans-edit?id='+row.item.ratePlanId"
												class="btn btn-sm btn-warning"
												target="__blank"
												v-if="$hasPermission('prices.show')">
												<md-icon icon="attach_money"></md-icon>
											</a>
										</template>
									</b-table>
								</div>
							</div>

							<!-- Mapa - Siempre visible -->
							<div class="map-section" v-if="selectedRow">
								<div class="map-container">
									<div class="map-header">
										<h6 class="mb-0">
											<md-icon icon="map" class="mr-2"></md-icon>
											Mapa de Zonas - {{ selectedRow.ride }}
										</h6>
									</div>
									<div class="map-details">
										<b-row>
											<b-col cols="12" md="4">
												<div class="detail-item mb-3">
													<small class="text-muted">Plan Tarifario:</small>
													<div class="font-weight-bold">{{ selectedRow.ratePlan }}</div>
												</div>
												<div class="detail-item">
													<small class="text-muted">Zona Origen → Destino:</small>
													<div>{{ selectedRow.zoneFrom }} → {{ selectedRow.zoneTo }}</div>
												</div>
											</b-col>
											<b-col cols="12" md="4">
												<div class="detail-item mb-3">
													<small class="text-muted">
														<md-icon icon="event" class="small-icon mr-1"></md-icon>
														Fechas de Asignación:
													</small>
													<div v-if="selectedRow.ratePlanStartDate && selectedRow.ratePlanEndDate">
														{{ formatDate(selectedRow.ratePlanStartDate) }}
														-
														{{ formatDate(selectedRow.ratePlanEndDate) }}
													</div>
													<div v-else class="text-muted">-</div>
												</div>
												<div class="detail-item" v-if="selectedRow.ratePlanModel && selectedRow.ratePlanModel.travelWindowStartDate && selectedRow.ratePlanModel.travelWindowEndDate">
													<small class="text-muted">
														<md-icon icon="date_range" class="small-icon mr-1"></md-icon>
														Travel Window:
													</small>
													<div>
														{{ formatDate(selectedRow.ratePlanModel.travelWindowStartDate) }}
														-
														{{ formatDate(selectedRow.ratePlanModel.travelWindowEndDate) }}
													</div>
												</div>
											</b-col>
											<b-col cols="12" md="4">
												<div class="detail-item mb-3">
													<small class="text-muted">Servicio Venta:</small>
													<div>{{ selectedRow.service }}</div>
												</div>
												<div class="detail-item" v-if="selectedRow.ratePlanModel && selectedRow.ratePlanModel.serviceStartTime && selectedRow.ratePlanModel.serviceEndTime">
													<small class="text-muted">
														<md-icon icon="schedule" class="small-icon mr-1"></md-icon>
														Horario Servicio:
													</small>
													<div>
														{{ formatTime(selectedRow.ratePlanModel.serviceStartTime) }} - {{ formatTime(selectedRow.ratePlanModel.serviceEndTime) }}
													</div>
												</div>
											</b-col>
										</b-row>
									</div>
									<GeoDetailsRide :geoDetails="getGeoDetails2(selectedRow)"></GeoDetailsRide>
								</div>
							</div>
						</b-tab>
						<b-tab title="Promociones" v-if="tracePromotion && tracePromotion.length > 0">
							<div class="d-flex w-100 flex-column mx-2">
								<h4>Promociones</h4>
								<TracePromotion :tracePromotion="tracePromotion"></TracePromotion>
							</div>
						</b-tab>
					</b-tabs>
				</b-modal>



				<hr />
				<b-row no-gutters>
					<b-col>
						<b-badge
							v-for="(aux, i) in $root.auxVars
								.transportServiceStatusOpts"
							:key="i"
							:variant="aux.class"
							class="mr-2"
							size=""
						>
							{{ aux.text }}
						</b-badge>
					</b-col>
				</b-row>
				<AjaxTable
					permission-show="supplierCost.show"
					id="supplier-prices-index-list"
					ref="childtable"
					stacked="lg"
					:selected-items.sync="items"
					:filters="filtersClean"
					:columns="modelColumns"
					:items-filter="itemsFilter"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="rates/prices"
					responsive
					:items.sync="itemsDisplayed"
				>
					<template #cell(actions)="row">
						<div class="d-flex">
							<b-button
								@click="
									event =>
										resView(
											row.item,
											row.index,
											event,
											row.item
										)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="visibility"></md-icon>
							</b-button>
						</div>
					</template>
					<template #cell(contactStatus)="row">
						{{ contactStatusLabels[row.item.contactStatus] }}
					</template>
					<template #cell(supplierCurrency)="row">
						<b-form-select
							style="width: 100px"
							size="sm"
							:options="optsCurrencies"
							v-model="row.item.supplierCurrency"
						></b-form-select>
					</template>
					<template #cell(pickup)="row">
						<b-button
							size="sm"
							v-if="
								row.item.pickup.latitude === null ||
									row.item.pickup.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.pickup.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.pickup.name }}
					</template>
					<template #cell(dropoff)="row">
						<b-button
							size="sm"
							v-if="
								row.item.dropoff.latitude === null ||
									row.item.dropoff.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.dropoff.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.dropoff.name }}
					</template>
					<template #cell(pax)="row">
						<span style="">{{
							row.item.adults +
								row.item.children +
								row.item.infants
						}}</span>
					</template>
					<template #cell(salesChannel)="row">
						<span style="white-space: nowrap;"
							><b-badge
								v-if="row.item.sourceLabel"
								variant="info"
								class="ml-1"
								>{{ row.item.sourceLabel }}</b-badge
							>
							{{ row.item.salesChannel }}</span
						>
					</template>
					<template #cell(pickupDatetime)="row">
						<span
							:class="
								row.item.pickupDatetimeConfirmed
									? 'text-success text-center'
									: 'text-warning text-center'
							"
						>
							<md-icon
								:icon="
									row.item.pickupDatetimeConfirmed
										? 'check_circle'
										: 'warning'
								"
							/>
						</span>
						{{ row.item.pickupDatetime }}
					</template>
					<template #cell(flightDatetime)="row">
						{{ row.item.flightDatetime }} /
						{{ row.item.flightNumber }}
					</template>
					<template #cell(supplierPriceTotal)="row">
						<b-input-group size="sm">
							<b-form-input
								disabled
								style="width: 100px"
								type="text"
								size="sm"
								v-model="row.item.supplierPriceTotal"
							/>
							<template #prepend>
								<b-input-group-text>$</b-input-group-text>
							</template>
						</b-input-group>
					</template>
					<template #cell(updateSupplierPriceTotal)="row">
						<b-input-group size="sm">
							<b-form-input
								style="width: 150px"
								type="text"
								size="sm"
								v-model="row.item.supplierPriceTotalUpdated"
							/>
							<template #prepend>
								<b-input-group-text>$</b-input-group-text>
							</template>
							<template #append>
								<b-button
									:disabled="
										!$hasPermission('supplierCost.update')
									"
									@click="event => calculatePrice(row.item)"
									type="button"
									size="sm"
									class="mr-1"
									variant="info"
								>
									<b-spinner
										small
										v-if="loadingRow === row.item.id"
									/>
									<md-icon v-else icon="refresh"></md-icon>
								</b-button>
								<b-button v-if="trace.lastCalculated === row.item.id" @click="openModalTrace">
									<md-icon  icon="info_outline"  ></md-icon>
								</b-button>
							</template>
						</b-input-group>
						<small v-if="row.index==0" style="cursor: pointer;" class="text-primary">
							<md-icon icon="info" v-b-tooltip.hover title="Doble click para aplicar función" />
							<a @dblclick="replicatePriceToAll($event,row.item)" href="#"  @click="(evt)=>{evt.preventDefault()}"> Aplicar a todos..</a>
						</small>
					</template>
					<!-- Supplier promo data -->
					<template #cell(supplierPromoData)="row">
						<span v-if="row.item.supplierPromoData != null" style="width: 200px;">
							{{ row.item.supplierPromoData.name }}
						</span>
					</template>
					<template #cell(supplier)="row">
						<span
							:class="
								iconSupplierConfirmation(
									row.item.supplierConfirmation
								).class
							"
						>
							<md-icon
								:icon="
									iconSupplierConfirmation(
										row.item.supplierConfirmation
									).icon
								"
							/>
						</span>
						{{ row.item.supplier }}
						<template v-if="row.item.lastRejectedSupplierName">
							<br />Rechazado por:
							{{ row.item.lastRejectedSupplierName }}
						</template>
					</template>
					<template #cell(serviceTypeSupplier)="row">
						{{ row.item.supplierServiceType}}
					</template>
					<template #cell(status)="row">
						{{ statusLabels[row.item.status] }}
					</template>
				</AjaxTable>
			</div>
			<FormReservation
				:tsSelectedId="selected.tsSelectedId"
				:model-id="selected.modalModelId"
				:copy-from-id="selected.copyResId"
				:formTypeWork="formTypeWork"
				@changeId="selected.modalModelId = $event"
				@onCopyRes="copyCurrentRes"
				v-model="form.add"
			/>
			<vue-snotify />
			<PlaceSingle
				ref="placeSingle"
				:success-callback="updatePlaceSuccessCallback"
			/>
		</div>

		<b-modal ref="modalTraceWithMap" size="xl">
			<map-zones ref="mapZones"/>
		</b-modal>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import AjaxTable from "../../helpers/AjaxTable";
import FormReservation from "@/components/sections/reservation/formReservation/index";
import api from "../../../api.js";
import Filters from "@/components/sections/reservations/Filters";
import PlaceSingle from "@/components/sections/places/Single";
import MapZones from "../rate-plans/Map.vue";
import TracePromotion from "../../helpers/TracePromo";
import GeoDetailsRide from "../../helpers/LeafletMap.vue";

export default {
	components: {
		MainLayout,
		FormReservation,
		AjaxTable,
		Filters,
		PlaceSingle,
		MapZones,
		TracePromotion,
		GeoDetailsRide
	},
	data() {
		let defaultFilters = {
			id: "",
			clientFullName: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			airport: [],
			serviceType: [],
			serviceTypeCategory: [],
			pickupStartDate: "",
			pickupStartTime: "",
			pickupEndDate: "",
			pickupEndTime: "",
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			creationUser:[],
			zones:[],
			invalidSupplierServiceType:false,
			tags:[],
			netPriceTotalStart:null,
			netPriceTotalEnd:null,
			supplierPriceTotalStart:null,
			supplierPriceTotalEnd:null,
			withSupplierPromo: false,
		};
		let columnsTrace =[
			{key:'ride',label:'Ride'},
			{key:'ratePlan',label:'Rate plan'},
			//{key:'ratePlanStartDate',label:'F. Asignación Inicio'},
			//{key:'ratePlanEndDate',label:'F. Asignación Fin'},
			//{key:'travelWindow',label:'Travel Window'},
			//{key:'serviceTime',label:'Horario Servicio'},
			{key:'zoneFrom',label:'Zona origen'},
			{key:'zoneTo',label:'Zona destino'},
			{key:'service',label:'Servicio venta'},
			{key:'supplierServiceType',label:'Servicio prov.'},
			{key:'msj',label:'Msj'},
			{key:'ratePlanId',label:'link'},
		]
		return {
			trace: {filter:"",items:[],lastCalculated:-1,columns:columnsTrace},
			tracePromotion: null,
			selectedRow: null,
			formTypeWork: "newForm", //viewForm -newForm- newFormCopy - newFormLocationReferences
			form: {
				add: false
			},
			selected: {
				modalModelId: -1,
				tsSelectedId: -1,
				copyResId: -1
			},
			loadingRow: -1,
			loadingExport: false,
			tsSelectedId: -1,
			items: [],
			itemsDisplayed: [],
			copyResId: -1,
			pendingNotifications: 0,
			exportLoading: false,
			modalModelId: -1,
			sortBy: "reservationId",
			sortDesc: true,
			filters: { ...defaultFilters },
			defaultFilters: { ...defaultFilters },
			updateAllSteps: [],
			runUpdateAll: false,
			modelColumns: [
				{
					key: "serviceNumber",
					label: "Res ID",
					sortable: true,
					disabled: false
				},
				{ key: "clientName", label: "Cliente" },
				{ key: "pickup", label: "Pickup" },
				{ key: "dropoff", label: "Dropoff" },
				{ key: "pax", label: "Pasajeros" },
				{
					key: "pickupDatetime",
					label: "Fecha Pickup",
					sortable: true
				},
				{ key: "flightDatetime", label: "Fecha Vuelo" },
				{ key: "serviceType", label: "Tipo servicio" },
				{ key: "salesChannel", label: "Canal de venta" },
				{ key: "salesChannelReference", label: "Referencia" },
				{ key: "supplierAssignedAt", label: "Fecha asignacion prov." },
				{ key: "supplier", label: "Proveedor" },
				//{ key: "supplierZoneFrom", label: "Zona pickup" },
				//{ key: "supplierZoneTo", label: "Zona dropoff" },
				{ key: "serviceTypeSupplier", label: "T. servicio proveedor" },
				{
					key: "supplierPriceTotal",
					label: "Costo actual",
					sortable: true
				},
				{ key: "updateSupplierPriceTotal", label: "Actualizar costo" },
				{ key: "supplierPromoData", label: "Promociones", width: "300px"},
				{ key: "supplierCurrency", label: "Moneda" },
				{ key: "trip", label: "Viaje" },
				{ key: "contactStatus", label: "Contacto" },

				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones", disabled: true }
			],
			pickupConfirmedOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CONFIRMADOS" },
				{ value: false, text: "NO CONFIRMADOS" }
			],
			fromPointOfSaleOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CON PUNTO DE VENTA" },
				{ value: false, text: "SIN PUNTO DE VENTA" }
			],
			openFilters: true,
		};
	},
	computed: {
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				destination: this.filters.destination.map(aux => aux.value),
				airport: this.filters.airport.map(aux => aux.value),
				salesChannel: this.filters.salesChannel.map(aux => aux.value),
				supplier: this.filters.supplier.map(aux => aux.value),
				creationUser: this.filters.creationUser.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				serviceTypeCategory: this.filters.serviceTypeCategory.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				pickupStartTime: this.filters.pickupStartTime,
				pickupEndTime: this.filters.pickupEndTime,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				trip: this.filters.trip,
				contactStatus: this.filters.contactStatus,
				revisedStatus: this.filters.revisedStatus,
				status: this.filters.status.map(aux => aux.value),
				statusCheckin: this.filters.statusCheckin.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				supplierReference: this.filters.supplierReference,
				containsEmail: this.filters.containsEmail,
				clientEdited: this.filters.clientEdited,
				clientConfirmed: this.filters.clientConfirmed,
				pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
				fromPointOfSale: this.filters.fromPointOfSale,
				supplierConfirmation: this.filters.supplierConfirmation,
				placesWithoutCoordinates: this.filters.placesWithoutCoordinates,
				supplierPriceTotalEmpty: this.filters.supplierPriceTotalEmpty,
				onlyWithAdditionalServices: this.filters.onlyWithAdditionalServices,
				oneway: this.filters.oneway,
				zones:this.filters.zones.map(aux => aux.value),
				invalidSupplierServiceType:this.filters.invalidSupplierServiceType,
				tags:this.filters.tags.map(aux => aux.value),
				netPriceTotalStart: this.filters.netPriceTotalStart,
				netPriceTotalEnd: this.filters.netPriceTotalEnd,
				supplierPriceTotalStart: this.filters.supplierPriceTotalStart,
				supplierPriceTotalEnd: this.filters.supplierPriceTotalEnd,
				withSupplierPromo: this.filters.withSupplierPromo
			};
		},
		contactStatusLabels() {
			let vars = this.$root.auxVars.transportServiceContactStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		serviceStatusVariants() {
			let aux = {};
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class;
			});
			return aux;
		},
		optsCurrencies() {
			return this.$root.auxVars.currencyOpts;
		}
	},
	methods: {
		convertMayus(text){
			return text.toUpperCase();
		},
		search() {
			this.$root.$emit(
				"bv::refresh::table",
				"supplier-prices-index-list"
			);
		},
		calculatePrice(item) {
			this.loadingRow = item.id;
			this.trace.lastCalculated = -1;
			this.tracePromotion = [];
			this.trace.items = [];
			this.selectedRow = null;
			api(this)
				.get(`/rates/supplier-prices/${item.id}`)
				.then(res => {
					this.trace.lastCalculated = item.id
					item.supplierPriceTotalUpdated =
						res.data.supplierPriceTotal;
					item.supplierCurrency = res.data.supplierCurrency;
					this.loadingRow = -1;
					this.$root.showAlert(
						`Costo calculado a $${item.supplierPriceTotalUpdated}`
					);
					//Add
					this.trace.items = res.data.trace??[];
					this.trace.items = this.trace.items.map(v => ({...v, _showDetails: true}))
					//guardamos la promocion
					this.tracePromotion = res.data.tracePromotion?? [];

					// Seleccionar la primera fila automáticamente si hay datos
					if (this.trace.items.length > 0) {
						this.selectedRow = this.trace.items[0];
					}
				})
				.catch(err => {
					this.loadingRow = -1;
					if(err.response.data.trace) this.trace.items = [...err.response.data.trace];
					this.$root.showAlert("No se encontró el precio", { variant: "danger" });

				}).finally(()=>{
					this.trace.lastCalculated = item.id
				})
		},
		updatePlaceSuccessCallback() {
			this.$root.$emit(
				"bv::refresh::table",
				"supplier-prices-index-list"
			);
		},
		openPlace(id) {
			this.$refs.placeSingle.loadModel(id);
		},
		doUpdateAll(offset = 0) {
			if (this.runUpdateAll) {
				this.$root.api
					.put(`rates/update-suppliers-prices-all`, {
						limit: 50,
						offset: offset,
						filters: this.filtersClean,
						sortBy: this.sortBy,
						sortOrder: this.sortDesc ? "desc" : "asc",
					})
					.then(res => {
						this.updateAllSteps.push(
							`Actualizacion de registros ${offset +
								1} al ${offset + 50}: Se actualizaron ${
								res.data.updated
							}, ${
								res.data.noCalculated
							} registros no se pudieron actualizar`
						);
						if (res.data.transportServices.length > 0) {
							this.doUpdateAll(offset + 50);
						} else {
							this.runUpdateAll = false;
						}
					})
					.catch(this.$root.handleRequestError);
			}
		},
		updateAll() {
			// primer request y toma el valor del total para calcular cuantas llamadas mas realizar
			this.runUpdateAll = true;
			this.updateAllSteps = [];
			this.doUpdateAll(0);
			// this.$root.showWarning({
			// 	okAction: (event, setLoading, close) => {
			// 		setLoading(true)
			// 		api(this).put(`/rates/update-suppliers-prices-all`, { filters : this.filtersClean }).then((res) => {
			// 			this.$root.showAlert(`Se actualizaron ${res.data.updated}, ${res.data.noCalculated} registros no se pudieron actualizar`)
			// 			this.$root.$emit('bv::refresh::table', 'supplier-prices-index-list')
			// 			close()
			// 		}).catch( err => {
			// 			this.$root.handleRequestError(err)
			// 			close()
			// 		});
			// 	}
			// })
		},
		updateAllView() {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.put(`/rates/update-suppliers-prices`, {
							transportServices: this.itemsDisplayed.map(
								item => ({
									id: item.id,
									supplierPriceTotal:
										item.supplierPriceTotalUpdated,
									supplierCurrency: item.supplierCurrency,
									tracePromotion: this.trace.lastCalculated==item.id?this.tracePromotion: null
								})
							),
							// tracePromotion: this.tracePromotion
						})
						.then(res => {
							this.$root.showAlert(
								`Se actualizaron ${res.data.updated} registros`
							);
							this.$root.$emit(
								"bv::refresh::table",
								"supplier-prices-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		copyCurrentRes() {
			this.selected.copyResId = this.selected.modalModelId;
			this.selected.modalModelId = -1;
			this.form.add = true;
		},
		itemsFilter(items) {
			if (!items) return [];
			return items.map(item => ({
				...item,
				supplierPriceTotalUpdated: item.supplierPriceTotal,
				_rowVariant: this.serviceStatusVariants[item.status]
			}));
		},
		resView(item) {
			this.selected.tsSelectedId = item.id;
			this.selected.copyResId = -1;
			this.selected.modalModelId = item.reservationId;
			this.form.add = true;
			//configuramos el estado de formulario formService
			this.formTypeWork = "viewForm";
		},
		iconSupplierConfirmation(status) {
			let icon = "";
			let classe = "";
			switch (status) {
				case "pending":
					icon = "warning";
					classe = "text-warning";
					break;
				case "confirmed":
					icon = "check_circle";
					classe = "text-success";
					break;
				case "rejected":
					icon = "dangerous";
					classe = "text-danger";
					break;
			}
			return { icon: icon, class: classe };
		},
		exportExcel() {
			this.loadingExport = true;
			api(this)
				.get(`/rates/supplier-prices/exportXls`, {
					params: { filters: this.filtersClean },
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "Supplier Prices");
				})
				.catch(err => {
					this.$root.handleRequestError(err);
				})
				.finally(() => {
					this.loadingExport = false;
				});
		},
		replicatePriceToAll(event,row){
			event.preventDefault();
			this.itemsDisplayed = this.itemsDisplayed.map((item)=>{
				item.supplierPriceTotalUpdated = row.supplierPriceTotalUpdated;
				return item;
			})
		},
		openModalTrace(){
			this.$refs["trace-data"].show()
		},
		getGeoDetails(row){
			try{
				return [row.item.supplierGeoDetails]
			}catch(err){
				console.log(err)
			}
			return [];
		},
		getGeoDetails2(row){
			try{
				return [row.supplierGeoDetails]
			}catch(err){
				console.log(err)
			}
			return [];
		},
		onRowSelected(items) {
			if (items.length > 0) {
				this.selectedRow = items[0];
			} else {
				this.selectedRow = null;
			}
		},
		formatDate(dateString) {
			if (!dateString) return '';
			try {
				const date = new Date(dateString);
				const options = { year: 'numeric', month: 'short', day: '2-digit' };
				return date.toLocaleDateString('es-ES', options);
			} catch (error) {
				return dateString;
			}
		},
		formatTime(timeString) {
			if (!timeString) return '';
			try {
				const timeParts = timeString.split(':');
				if (timeParts.length >= 2) {
					return `${timeParts[0]}:${timeParts[1]}`;
				}
				return timeString;
			} catch (error) {
				return timeString;
			}
		}
	},
	mounted() {

	},
	created() {},
	watch: {}
};
</script>

<style scoped>
	.detail-table td {
		padding: 0.4rem;
		vertical-align: middle;
	}
	.detail-table .amount {
		text-align: end;
	}

	.small-icon {
		font-size: 14px;
		vertical-align: middle;
	}

	.text-nowrap {
		white-space: nowrap;
	}

	.table-section {
		width: 100%;
	}

	.table-container {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		background: #fff;
		border-radius: 0.25rem;
	}

	.map-section {
		width: 100%;
		margin-top: 1.5rem;
	}

	.map-container {
		background: #fff;
		border-radius: 0.25rem;
		border: 1px solid #dee2e6;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.map-header {
		padding: 1rem 1.25rem;
		background-color: #f8f9fa;
		border-bottom: 2px solid #dee2e6;
	}

	.map-header h6 {
		margin: 0;
		font-size: 1rem;
		font-weight: 600;
		display: flex;
		align-items: center;
		color: #495057;
	}

	.map-details {
		padding: 1rem 1.25rem;
		background-color: #f8f9fa;
		border-bottom: 1px solid #dee2e6;
	}

	.detail-item {
		margin-bottom: 0;
	}

	.detail-item small {
		display: flex;
		align-items: center;
		color: #6c757d;
		font-size: 0.75rem;
		margin-bottom: 0.35rem;
		font-weight: 600;
	}

	.detail-item .font-weight-bold {
		font-size: 0.95rem;
		color: #212529;
		line-height: 1.4;
	}

	.detail-item div:not(.font-weight-bold) {
		font-size: 0.85rem;
		color: #495057;
		line-height: 1.5;
	}

	.detail-item .text-muted {
		font-style: italic;
		font-size: 0.8rem;
	}

	@media (max-width: 768px) {
		.map-header {
			padding: 0.75rem 1rem;
		}

		.map-details {
			padding: 0.75rem 1rem;
		}

		.map-header h6 {
			font-size: 0.9rem;
		}
	}
</style>

<style>
.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}
.active-filter {
	border: 2px solid #021d3e;
}
.snotifyToast__title {
	font-size: 1.5em;
}
.inline-heading {
	display: inline;
}
.inline-button {
	margin-bottom: 10px;
}

/* Estilos para el modal de trace */
.trace-modal .modal-dialog {
	width: 98% !important;
	max-width: inherit;
	margin: 0.5rem auto;
}

.trace-modal .modal-content {
	overflow: hidden;
}

.trace-modal .modal-body {
	padding: 0.5rem;
	overflow-x: hidden;
}

@media (min-width: 1200px) {
	.trace-modal .modal-dialog {
		max-width: 95%;
		margin: 1rem auto;
	}

	.trace-modal .table {
		font-size: .85rem;
	}
}

@media (min-width: 1400px) {
	.trace-modal .modal-dialog {
		max-width: 1380px;
	}
}

.trace-modal .table {
	margin-bottom: 0;
	width: 100%;
}

.trace-modal .table td {
	vertical-align: middle;
	padding: 0.5rem 0.4rem;
	font-size: 0.85rem;
	max-width: 250px;
	word-wrap: break-word;
}

.trace-modal .table th {
	background-color: #f8f9fa;
	font-weight: 600;
	font-size: 0.75rem;
	padding: 0.6rem 0.4rem;
	border-bottom: 2px solid #dee2e6;
	white-space: nowrap;
	position: sticky;
	top: 0;
	z-index: 10;
}

.trace-modal .table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(0,0,0,.02);
}

.trace-modal .table-hover tbody tr:hover {
	background-color: rgba(0,0,0,.04);
}

.trace-modal .btn-sm {
	padding: 0.25rem 0.5rem;
	font-size: 0.75rem;
}

.trace-modal small {
	font-size: 0.8rem;
	line-height: 1.4;
}
</style>
